import { ActionIcon, Button, Menu } from '@mantine/core';
import * as icons from '@sloyd/icons';
import classes from './SplitButton.module.css';
import { Wrapper } from './SplitButton.style';

export type SplitButtonProps = {
  iconName: string;
  options: string[];
  value?: string;
  onClick: (option: string) => void;
  onChange: (option: string) => void;
  isLoading?: boolean;
};

export function SplitButton(props: SplitButtonProps) {
  const { iconName, options, value, isLoading } = props;

  function onClick() {
    if (!value) return;
    props.onClick(value);
  }

  function renderOption(option: string) {
    return (
      <Menu.Item key={option} onClick={() => props.onChange(option)}>
        {option}
      </Menu.Item>
    );
  }

  function renderOptions() {
    return options.map((option: string) => renderOption(option));
  }

  const Cmp = (icons as any)[iconName];

  function renderMenu() {
    if (isLoading) return;

    return (
      <Menu transitionProps={{ transition: 'pop' }} position='bottom-end' withinPortal>
        <Menu.Target>
          <ActionIcon variant='filled' color='pink' size={30} className={classes.menuControl}>
            <icons.IconChevronDown size={16} stroke={1.5} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>{renderOptions()}</Menu.Dropdown>
      </Menu>
    );
  }

  return (
    <Wrapper className='SplitButton-wrapper' data-testid='SplitButton-wrapper'>
      <Button
        onClick={onClick}
        leftSection={Cmp && <Cmp size={14} />}
        className={!isLoading ? classes.buttonSplit : ''}
        color='pink'
        size='xs'
        loading={isLoading}
      >
        Download {value}
      </Button>
      {renderMenu()}
    </Wrapper>
  );
}

export default SplitButton;
